module.exports = __webpack_public_path__ + "img/project-6.02369f45.jpg";